import script from "./CardChartV2Component.vue?vue&type=script&setup=true&lang=js"
export * from "./CardChartV2Component.vue?vue&type=script&setup=true&lang=js"

import "./CardChartV2Component.vue?vue&type=style&index=0&id=5609efd3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5609efd3"]])

export default __exports__